import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionBadge } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export default function FAQ() {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <SectionBadge label={t("faq.badge")} testId="faq-badge" />
          <h2 className="font-display mt-5 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-[#EAE6E1]">
            {t("faq.heading")}
          </h2>
          <p className="mt-4 max-w-md text-base text-[#9E9E9E] leading-relaxed">
            {t("faq.sub")}
          </p>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#262930]"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display text-base sm:text-lg font-semibold text-[#EAE6E1] hover:text-[#8C9A86] hover:no-underline transition-colors duration-200"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm sm:text-base leading-relaxed text-[#9E9E9E]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
